import {useState} from 'react'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {useIntl} from 'react-intl'
import { error } from 'console'
import { DataRangeFilter } from '../../parts/filters/DataRangeFilter'
import { ServerFilter } from '../../parts/filters/ServerFilter'
import moment from 'moment'
import { KeywordsFilter } from '../../parts/filters/KeywordsFilter'

export const SearchKeywords = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')
  const [keywords, setKeywords] = useState<any>([])
  const [error_keyword, setErrorKeyword] = useState('')

  const submitData = async () => {
    let has_error = false
    setError('')
    if ( server === 'oneormore' && (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorKeyword('')
    if (keywords === null || (Array.isArray(keywords) && keywords.length === 0)) {
      setErrorKeyword(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_KEYWORDS'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    setErrorKeyword('')
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server: server === 'oneormore' && serversSelected ? serversSelected.map((srv: any) => srv.value) : [],
      tz: new Date().getTimezoneOffset(),
      keywords: keywords.map((kw: any) => kw.value),
    }
    setFilterData(data)
  }

  let params: any = {
    title: intl.formatMessage({id: 'REPORT_DEVICE.KEYWORDS.TITLE'}),
    yAxisTitle: intl.formatMessage({id: 'REPORT_DEVICE.KEYWORDS.YAXISTITLE'}),

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  return (
    <>
      <CrudProvider api='reports/keywords'>
        <ChartsComponent
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'REPOER_DEVICE.KEYWORDS.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <KeywordsFilter
            onChange={(_keywords:any) => {
              setKeywords(_keywords)
            }}
          />
          {error_keyword && <div className='alert alert-danger'>{error_keyword}</div>}

          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float: 'left'}}
          />{' '}
          {loading && (
            <div
              className='spinner-border text-primary'
              role='status'
              style={{marginTop: '7px', float: 'left', marginLeft: '10px'}}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          )}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
